// Utilities
import { getIntegration } from '@builder/core/directory/integrations';

const { isEmpty } = _uo.utility;

/**
 * Retrieves global information about a specific item using the item code. This function does not return the item inside
 * the recipe.
 *
 * @param {String} integrationCode The integration code. E.g. `WP`.
 * @param {String} loopFilterCode The loop filter code. E.g. `WP_USER_EMAIL_ENDS_WITH`
 * @throws {Error} - Throws an error if the integration code or loop filter code are not defined.
 * @return {Object|undefined} Returns the loop filter object if found; otherwise, undefined.
 */
const getLoopFilter = ( integrationCode, loopFilterCode ) => {
	if ( isEmpty( integrationCode ) ) {
		throw new Error( `directory/getLoopFilter: The integration code must be defined` );
	}

	if ( isEmpty( loopFilterCode ) ) {
		throw new Error( `directory/getLoopFilter: The loop filter code must be defined` );
	}

	// Get the integration
	const integration = getIntegration( integrationCode );

	// If the integration doesn't exist, neither does the item. Return `undefined`
	if ( isEmpty( integration ) ) {
		return;
	}

	// Check if the item exists
	if ( isEmpty( integration.loop_filters[ loopFilterCode ] ) ) {
		return;
	}

	return integration.loop_filters[ loopFilterCode ];
}

export default getLoopFilter;
